export default __webpack_public_path__ + "media/images/dog-on-field-1-006b0d8b685bf50dc1da87db867c567a.png";